import { observer } from 'mobx-react-lite';
import { Button, Container, Header, Segment } from 'semantic-ui-react';
import { User } from '../../../app/models/user';
import { useStore } from '../../../app/stores/store';
import ShippingForm from '../../user/ShippingForm';
import ShippingAddressContent from '../common/ShippingAddressContent';

interface Props {
    user: User
}
export default observer(function PermitDashboardShippingAddressContent({ 
    user
}: Props) {
    const {userStore, modalStore} = useStore();
    const {openModal} = modalStore;
    const {setShippingSameInd} = userStore;

    return (
        <Segment>
            <Header 
                as='h2' 
                dividing 
                content='Shipping Address'
                color='teal' 
                floated='left' 
            />
            <Button
                floated='right'
                onClick={() => openModal(<ShippingForm isRedirect={true} />)}
                content='Edit'
                size='tiny'
            />
            <Container className='clear-both'>
                {user.homeShippingSameInd === 'y' ? 
                    <>
                        <span>Using Primary Account Address!</span>
                    </>
                    : 
                    <>
                        <ShippingAddressContent user={user!}/>
                        <div>
                            <Button
                                fluid
                                primary
                                onClick={() => setShippingSameInd()}
                            >
                                Use Primary Address!
                            </Button>
                        </div>
                    </>}
            </Container>
        </Segment>
    )
})